import { handleWoocommerceToasts } from '../modules/handleWoocommerceToasts';
const toasts = [];
const handleCouponField = () => {
    const couponFieldsWrapper = document.querySelector(
        '.cart-page__coupon-fields-wrapper'
    );
    if (couponFieldsWrapper) {
        const input = couponFieldsWrapper.querySelector('input');
        const button = couponFieldsWrapper.querySelector('button');

        input.addEventListener('input', e => {
            const { value } = e.target;

            if (value) {
                button.classList.add('-show');
            } else {
                button.classList.remove('-show');
            }
        });
    }
};
handleCouponField();
$(document.body).on('updated_cart_totals', function () {
    handleWoocommerceToasts(toasts);
    handleCouponField();
});

$(document.body).on('wc_cart_emptied', function () {
    handleWoocommerceToasts(toasts);
});

jQuery(document).ajaxComplete(function (event, xhr, settings) {
    if (
        jQuery('body').hasClass('woocommerce-checkout') ||
        jQuery('body').hasClass('woocommerce-cart')
    ) {
        jQuery('html, body').stop();
    }
});
